import React from "react";
import { motion } from "framer-motion";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";

export default function Contact() {
  return (
    <section id="contact" className="max-w-5xl mx-auto px-6 pb-24">

      {/* Heading */}
      <motion.h2
        initial={{ opacity: 0, y: 8 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
        className="text-2xl font-bold text-black dark:text-white mb-10"
      >
        Contact
      </motion.h2>

      {/* Glass Card */}
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="
          rounded-3xl border border-black/10 dark:border-white/10
          bg-white/70 dark:bg-white/5 backdrop-blur-xl
          shadow-[0_20px_60px_rgba(0,0,0,0.08)] dark:shadow-[0_20px_60px_rgba(0,0,0,0.5)]
          p-10 text-center
        "
      >
        {/* Message */}
        <p className="text-black/70 dark:text-white/70 text-lg max-w-xl mx-auto">
          Feel free to reach out anytime.
          I’d be happy to connect and have a conversation.
        </p>

        {/* Buttons */}
        <div className="mt-8 flex flex-wrap justify-center gap-4">

          {/* Email */}
          <a
          href="https://mail.google.com/mail/?view=cm&fs=1&to=rajan23parthi@gmail.com&su=Portfolio%20Contact&body=Hello%20Parthibarajan,%20I%20saw%20your%20portfolio%20and%20would%20like%20to%20connect."
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-2 px-5 py-3 rounded-xl
          bg-white text-black font-medium hover:scale-105 transition"
          >
           Email
        </a>



          {/* GitHub */}
          <a
            href="https://github.com/Parthistark23"
            target="_blank"
            rel="noreferrer"
            className="
              flex items-center gap-2 px-5 py-3 rounded-xl
              border border-black/20 dark:border-white/20
              text-black dark:text-white
              hover:bg-black/5 dark:hover:bg-white/10
              hover:scale-105 transition
            "
          >
            <FaGithub size={18} />
            GitHub
          </a>

          {/* LinkedIn */}
          <a
            href="https://www.linkedin.com/in/parthibarajan001/"
            target="_blank"
            rel="noreferrer"
            className="
              flex items-center gap-2 px-5 py-3 rounded-xl
              border border-black/20 dark:border-white/20
              text-black dark:text-white
              hover:bg-black/5 dark:hover:bg-white/10
              hover:scale-105 transition
            "
          >
            <FaLinkedin size={18} />
            LinkedIn
          </a>

          {/* Resume */}
          <a
            href="/resume.pdf"
            download
            className="
              flex items-center gap-2 px-5 py-3 rounded-xl
              border border-black/20 dark:border-white/20
              text-black dark:text-white
              hover:bg-black/5 dark:hover:bg-white/10
              hover:scale-105 transition
            "
          >
            <FiDownload size={18} />
            Resume
          </a>

        </div>
      </motion.div>
    </section>
  );
}
